// extracted by mini-css-extract-plugin
export default {"BiblioCount":"BiblioCount_BiblioCount__Dxtzn","hyperlink":"BiblioCount_hyperlink__7lN4x"};